<template>
  <div class="modal-overlay" @click="$emit('close')">
    <div class="modal-window" :style="backgroundStyle" @click.stop>
      <div class="modal-header" v-if="!hideHeader" :style="titleStyle">
        <slot name="header"></slot>
        <button class="modal-close-button" @click="$emit('close')">
          <img src="./icons/close.png" width="24" alt="">
        </button>
      </div>
      <div class="modal-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    background: String,
    titleBgColor:String,
    hideHeader: Boolean,
  },
  computed: {
    titleStyle() {
      return {
        backgroundColor: this.titleBgColor,
      }
    },
    backgroundStyle() {
      if (this.background?.startsWith('http')) {
        return {
          backgroundImage: `url(${this.background})`,
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
        }
      } else {
        return {
          backgroundColor: this.background,
        }
      }
    },
  },
  mounted() {
    document.body.style.overflow = 'hidden'
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  },
}
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal-window {
  width: 375px;
  position: fixed;
  top: 0%;
  left: 50%;
  // border-radius: 15px;
  transform: translate(-50%, 0%);
  background-color: white;
}

.modal-header {
  display: flex;
  text-align: center;
  justify-content: space-between;
  padding: 15px;
}

.modal-close-button {
  cursor: pointer;
  background: transparent;
  border: 0;
}
</style>
